import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'

export default class CourierOperator extends ApiBase {
  constructor(store) {
    super(store, `${ACTIVE_BASE_REST}/courier/operator`)
  }

  updateRoles(id, model, showProgress) {
    return this._request({
      action: `${id}/role`,
      method: 'PATCH',
      body: model,
      showProgress
    })
  }
}
